import { styled } from '@mui/material/styles';
import { DialogTitle } from '@mui/material';

export const TitleDialog = styled(DialogTitle)`
  position: relative;
  padding-top: 16px;
  color: rgba(0,0,0,0.6);
  &:after {
    content: ' ';
    background-color: #ccc;
    width: calc(100% + 40px);
    height: 1px;
    position: absolute;
    left: -40px;
    bottom: 10px;
  }
`;